import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./application/pages/Layout";
import Home from "./application/pages/Home";
import Contact from "./application/pages/Contact";
import AboutUs from "./application/pages/WhoWeAre/AboutUs";
import OurTeam from "./application/pages/WhoWeAre/OurTeam";
import Ourjourney from "./application/pages/WhoWeAre/Ourjourney";
import VisionMission from "./application/pages/WhoWeAre/VisionMission";
import Education from "./application/pages/OurWork/Education";
import Health from "./application/pages/OurWork/Health";
import Environment from "./application/pages/OurWork/Environment";
import CareAndProtection from "./application/pages/OurWork/CareAndProtection";
import NoPage from "./application/pages/NoPage";
import './App.css';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/aboutUs" element={<AboutUs />} />
          <Route path="/Ourjourney" element={<Ourjourney />} />
          <Route path="/VisionMission" element={<VisionMission />} />
          <Route path="/OurTeam" element={<OurTeam />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route path="*" element={<NoPage />} />
          {/*****************  Our Work Module ********************/}
          <Route path="/education" element={<Education />} />
          <Route path="/health" element={<Health />} />
          <Route path="/environment" element={<Environment />} />
          <Route path="/careAndProtection" element={<CareAndProtection />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);